export default "__VITE_ASSET__nB_GgCgm__"